import React from 'react'
import "../styles/input.css"
export const Input = () => {
    return (
        <textarea type="text" id="input" placeholder="webTerminal@home:~$" />
    )
}
